import styles from './Logo.module.scss'
import React, { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const Top: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)
  return (
    <section
      className={`${styles.logo} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <ul className={styles.logo__list}>
        {/* <li className={styles.logo__list__item}>
          <img src="/img/LP/zebra/logo_coca.svg" alt="coca" width={90} height={22} />
        </li> */}
        <li className={styles.logo__list__item}>
          <img src="/img/LP/zebra/logo_daiwa.png" alt="大和ハウスフィナンシャル" width={114} height={28} />
        </li>
        <li className={styles.logo__list__item}>
          <img src="/img/LP/zebra/logo_megane.svg" alt="メガネスーパー" width={130} height={21} />
        </li>
        <li className={styles.logo__list__item}>
          <img src="/img/LP/zebra/logo_peach.png" alt="PEACH JOHN" width={129} height={15} />
        </li>
        <li className={styles.logo__list__item}>
          <img src="/img/LP/zebra/logo_bigi.svg" alt="BIGI CO., LTD." width={120} height={18} />
        </li>
        <li className={styles.logo__list__item}>
          <img src="/img/LP/zebra/logo_pink.png" alt="PINK HOUSE" width={100} height={27} />
        </li>
        <li className={styles.logo__list__item}>
          <img src="/img/LP/zebra/logo_mirron.svg" alt="mirron" width={120} height={26} />
        </li>
      </ul>
    </section>
  )
}
export default Top
